import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Button, Modal, Form } from "react-bootstrap";
import { RBTable } from "@pallassystems/react-bootstrap-table";
import Breadcrumb from "app/components/Breadcrumb";
import { axios } from "fake-db/mock";

export default function SetSalary() {
  const [activeLeft, setActiveLeft] = useState("basic");
  const [tableDataMap, setTableDataMap] = useState({
    basic: [
      {
        monthYear: "2026-01",
        payslipType: "Monthly",
        basicsalary: 30000,
        action: "View",
      },
    ],

    allowances: [
      {
        monthYear: "2026-01",
        allowanceType: "Taxable",
        allowanceTitle: "HRA",
        allowanceAmount: 5000,
        action: "View",
      },
    ],

    commissions: [
      {
        monthYear: "2026-01",
        commissionTitle: "Sales",
        commissions: 8000,
        action: "View",
      },
    ],

    loan: [
      {
        monthYear: "2026-01",
        loan: "Home Loan",
        loanAmount: 50000,
        loanTime: "12 Months",
        loanRemaining: 30000,
        action: "View",
      },
    ],

    statutory: [
      {
        monthYear: "2026-01",
        deductionType: "PF",
        title: "Provident Fund",
        amount: 1800,
        action: "View",
      },
    ],

    other: [
      {
        monthYear: "2026-01",
        title: "Bonus",
        amount: 5000,
        action: "View",
      },
    ],

    overtime: [
      {
        monthYear: "2026-01",
        title: "Night Shift",
        noofDays: 5,
        totalHours: 20,
        rate: 300,
        action: "View",
      },
    ],
  });

  const [showModal, setShowModal] = useState(false);
  const [users, setUsers] = useState([]);

  const [formData, setFormData] = useState({});

  const [pensionData, setPensionData] = useState({
    pensionType: "",
    amount: 0,
  });

  //Left Menu
  const leftMenu = [
    { key: "basic", label: "Basic Salary", btn: "Add Basic Salary" },
    { key: "allowances", label: "Allowances", btn: "Add Allowance" },
    { key: "commissions", label: "Commissions", btn: "Add Commission" },
    { key: "loan", label: "Loan", btn: "Add Loan" },
    { key: "statutory", label: "Statutory Deductions", btn: "Add Deduction" },
    { key: "other", label: "Other Payment", btn: "Add Payment" },
    { key: "overtime", label: "Overtime", btn: "Add Overtime" },
    { key: "pension", label: "Salary Pension", btn: "Add Pension" },
  ];

  const activeMenu = leftMenu.find((item) => item.key === activeLeft);
  const tableData = tableDataMap[activeLeft] || [];
  // Columns per menu
  const tableColumns = {
    basic: [
      { accessorKey: "monthYear", header: "Month Year", searchable: true },
      { accessorKey: "payslipType", header: "Payslip Type" },
      { accessorKey: "basicsalary", header: "Basic Salary" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    allowances: [
      { accessorKey: "monthYear", header: "Month-Year", searchable: true },
      { accessorKey: "allowanceType", header: "Allowance Type" },
      { accessorKey: "allowanceTitle", header: "Allowance Title" },
      { accessorKey: "allowanceAmount", header: "Allowance Amount" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    commissions: [
      { accessorKey: "monthYear", header: "Month-Year", searchable: true },
      { accessorKey: "commissionTitle", header: "Commission Title" },
      { accessorKey: "commissions", header: "Commissions" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],

    loan: [
      { accessorKey: "monthYear", header: "Month-Year", searchable: true },
      { accessorKey: "loan", header: "Loan " },
      { accessorKey: "loanAmount", header: "Loan Amount" },
      { accessorKey: "loanTime", header: "Loan Time" },
      { accessorKey: "loanRemaining", header: "Loan Remaining" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    statutory: [
      { accessorKey: "monthYear", header: "Month Year", searchable: true },
      { accessorKey: "deductionType", header: "Deduction Type" },
      { accessorKey: "title", header: "Title" },
      { accessorKey: "amount", header: "Amount" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    other: [
      { accessorKey: "monthYear", header: "Month Year", searchable: true },
      { accessorKey: "title", header: "Title" },
      { accessorKey: "amount", header: "Amount" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
    overtime: [
      { accessorKey: "monthYear", header: "Month Year", searchable: true },
      { accessorKey: "title", header: "Title" },
      { accessorKey: "noofDays", header: "Number Of Days" },
      { accessorKey: "totalHours", header: "Total Hours" },
      { accessorKey: "rate", header: "Rate" },
      {
        accessorKey: "action",
        header: "Action",
        style: { width: "100px", textAlign: "center" },
        Cell: () => {
          return (
            <div className="d-flex justify-content-start">
              <Button
                className="btn-icon d-flex align-items-center justify-content-center"
                style={{
                  width: "32px",
                  height: "32px",
                  backgroundColor: "#663399",
                  border: "none",
                }}
                onClick={() => {}}
              >
                <i className="i-Eye text-18 text-white"></i>
              </Button>
            </div>
          );
        },
      },
    ],
  };

  const columns = useMemo(() => {
    return tableColumns[activeLeft] || [];
  }, [activeLeft]);

  // Handle modal form change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    axios.get("/api/user/all").then(({ data }) => {
      const userList = data.map((item, ind) => ({
        age: item.age,
        index: ind + 1,
        name: item.name,
        email: item.email,
        balance: item.balance,
        company: item.company,
      }));
      setUsers(userList);
    });
  }, []);

  const handlePensionChange = (e) => {
    const { name, value } = e.target;
    setPensionData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePensionAdd = () => {
    console.log("PENSION DATA:", pensionData);

    alert("Pension updated successfully");

    setPensionData({
      pensionType: "",
      amount: 0,
    });
  };

  // Handle Add button inside modal
  const handleAdd = () => {
    let newRow = {};

    if (activeLeft === "basic") {
      newRow = {
        monthYear: formData.monthYear,
        payslipType: formData.payslipType,
        basicsalary: formData.amount,
        action: "View",
      };
    }

    if (activeLeft === "allowances") {
      newRow = {
        monthYear: formData.monthYear,
        allowanceType: formData.allowanceType || "Rent",
        allowanceTitle: formData.allowanceTitle || "House Rent",
        allowanceAmount: formData.amount,
        action: "View",
      };
    }

    if (activeLeft === "commissions") {
      newRow = {
        monthYear: formData.monthYear,
        commissionTitle: formData.commissionTitle,
        commissions: formData.amount || 8000,
        action: "View",
      };
    }

    if (activeLeft === "loan") {
      newRow = {
        monthYear: formData.monthYear,
        loan: formData.loanOption || "Home Loan",
        loanAmount: formData.amount || 50000,
        loanTime: formData.installments || "12 Months",
        loanRemaining: formData.amount || 30000,
        action: "View",
      };
    }

    if (activeLeft === "statutory") {
      newRow = {
        monthYear: formData.monthYear,
        deductionType: formData.deductionOption || "PF",
        title: formData.deductionTitle || "Provident Fund",
        amount: formData.amount,
        action: "View",
      };
    }

    if (activeLeft === "other") {
      newRow = {
        monthYear: formData.monthYear,
        title: formData.title || "Bonus",
        amount: formData.amount,
        action: "View",
      };
    }

    if (activeLeft === "overtime") {
      newRow = {
        monthYear: formData.monthYear,
        title: formData.title || "Overtime",
        noofDays: formData.noofDays || 0,
        totalHours: formData.totalHours || 0,
        rate: formData.rate || 0,
        action: "View",
      };
    }

    console.log("ADDING ROW:", activeLeft, newRow);

    setTableDataMap((prev) => ({
      ...prev,
      [activeLeft]: [...prev[activeLeft], newRow],
    }));

    setShowModal(false);
  };

  return (
    <section>
      <Breadcrumb
        routeSegments={[
          { name: "Dashboard", path: "/" },
          { name: "Set Salary" },
        ]}
      />

      <Card className="p-4 shadow-sm">
        <h6 className="mt-4 mb-3">Salary Info</h6>

        <Row>
          {/* Left Menu */}
          <Col md={3}>
            <Card>
              {leftMenu.map((item) => (
                <div
                  key={item.key}
                  onClick={() => setActiveLeft(item.key)}
                  className={`p-3 border-bottom cursor-pointer ${
                    activeLeft === item.key ? "text-primary fw-semibold" : ""
                  }`}
                >
                  {item.label}
                </div>
              ))}
            </Card>
          </Col>

          {/* Right Side Content */}
          <Col md={9}>
            {/*Button – pension tab par nahi */}
            {activeLeft !== "pension" && (
              <div className="mb-3 d-flex justify-content-start">
                <Button
                  className="btn-icon d-flex align-items-center text-white border-0 shadow-none"
                  style={{ backgroundColor: "#663399" }}
                  onClick={() => setShowModal(true)}
                >
                  <span className="ul-btn__icon">
                    <i className="i-Add text-18"></i>
                  </span>
                  <span className="ul-btn__text ml-2">{activeMenu?.btn}</span>
                </Button>
              </div>
            )}

          
            {activeLeft !== "pension" && (
              <RBTable
                data={tableData}
                key={activeLeft}
                columns={columns}
                varient="primary"
                footer={{ enablePagination: true }}
                header={{
                  enableFilters: true,
                  enableDensityToggle: true,
                  enableExportButton: true,
                }}
              />
            )}

            {/*  Pension UI*/}
            {activeLeft === "pension" && (
              <Card className="p-4 shadow-sm">
                <h6 className="mb-4">Update Pension</h6>

                <Row className="g-4">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Pension Type</Form.Label>
                      <Form.Select
                        name="pensionType"
                        value={pensionData.pensionType}
                        onChange={handlePensionChange}
                      >
                        <option value="">Select Pension Type...</option>
                        <option value="Fixed">Fixed</option>
                        <option value="Percentage">Percentage</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>(₹) Amount</Form.Label>
                      <Form.Control
                        type="number"
                        name="amount"
                        value={pensionData.amount}
                        onChange={handlePensionChange}
                        placeholder="0"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end mt-4">
                  <Button
                    className="text-white border-0"
                    onClick={handlePensionAdd}
                    style={{
                      backgroundColor: "#663399",
                      padding: "8px 28px",
                      borderRadius: "6px",
                    }}
                  >
                    Add
                  </Button>
                </div>
              </Card>
            )}
          </Col>
        </Row>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{activeMenu?.btn}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Basic Modal */}
            {activeLeft === "basic" && (
              <Row className="mb-3">
                {/* First Column */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Second Column */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payslip Type *</Form.Label>
                    <Form.Select
                      name="payslipType"
                      value={formData.payslipType}
                      onChange={handleChange}
                    >
                      <option value="">Select Payslip Type..</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Hourly">Hourly</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                {/* Third Column*/}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>₹ Basic Salary *</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
            {/* Allowence Modal */}

            {activeLeft === "allowances" && (
              <Row className="g-5">
                {" "}
               
                {/* Month-Year */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                {/* Allowance Type */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Allowance Type *</Form.Label>
                    <Form.Select
                      name="allowanceType"
                      value={formData.allowanceType || ""}
                      onChange={handleChange}
                    >
                      <option value="">Select Allowance Type...</option>
                      <option value="Taxable">Taxable</option>
                      <option value="Non-Taxable">Non-Taxable</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                {/* Allowance Title */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Allowance Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="allowanceTitle"
                      value={formData.allowanceTitle || ""}
                      onChange={handleChange}
                      placeholder="Allowance"
                    />
                  </Form.Group>
                </Col>
                {/* Allowance Amount */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>₹ Allowance Amount *</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={formData.amount || ""}
                      onChange={handleChange}
                      placeholder="Allowance"
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Commission Modal */}
            {activeLeft === "commissions" && (
              <Row className="mb-3">
                {/* First Column */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Second Column */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Commission Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="commissionTitle"
                      value={formData.commissionTitle || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Third Column*/}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>₹ Commission Amount*</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={formData.amount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Loan Modal */}
            {activeLeft === "loan" && (
              <Row className="g-3">
                {/* Month-Year */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Loan Option */}
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Loan Option *</Form.Label>
                    <Form.Control
                      type="text"
                      name="loanOption"
                      value={formData.loanOption || ""}
                      onChange={handleChange}
                      placeholder="Select Loan Option..."
                    />
                  </Form.Group>
                </Col>

                {/* Title */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={formData.title || ""}
                      onChange={handleChange}
                      placeholder="Title"
                    />
                  </Form.Group>
                </Col>

                {/* Amount */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>₹ Amount *</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={formData.amount || ""}
                      onChange={handleChange}
                      placeholder="Amount"
                    />
                  </Form.Group>
                </Col>

                {/* Number of Installments */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Number of Installments</Form.Label>
                    <Form.Control
                      type="number"
                      name="installments"
                      value={formData.installments || ""}
                      onChange={handleChange}
                      placeholder="Number"
                    />
                  </Form.Group>
                </Col>

                {/* Reason */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Reason</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={1}
                      name="reason"
                      value={formData.reason || ""}
                      onChange={handleChange}
                      placeholder="Reason"
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Statutary Modal */}
            {activeLeft === "statutory" && (
              <Row className="g-5">
                {/* Month-Year */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                {/* Deduction Option as text box */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Deduction Option *</Form.Label>
                    <Form.Control
                      type="text"
                      name="deductionOption"
                      value={formData.deductionOption || ""}
                      onChange={handleChange}
                      placeholder="Deduction"
                    />
                  </Form.Group>
                </Col>

                {/* Deduction Title */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Deduction Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="deductionTitle"
                      value={formData.deductionTitle || ""}
                      onChange={handleChange}
                      placeholder="Deduction"
                    />
                  </Form.Group>
                </Col>

                {/* Deduction Amount */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>₹ Deduction Amount *</Form.Label>
                    <Form.Control
                      type="number"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      name="amount"
                      value={formData.amount || ""}
                      onChange={handleChange}
                      placeholder="Deduction"
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Other Modal */}
            {activeLeft === "other" && (
              <Row className="g-5">
                {/* Month-Year */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Title*</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={formData.title || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>₹ Amount *</Form.Label>
                    <Form.Control
                      type="number"
                      name="amount"
                      value={formData.amount || ""}
                      onChange={handleChange}
                      placeholder="Amount"
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Overtime Modal */}
            {activeLeft === "overtime" && (
              <Row className="g-5">
                {/* Month-Year */}
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Month Year *</Form.Label>
                    <Form.Control
                      type="month"
                      name="monthYear"
                      value={formData.monthYear || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      name="title"
                      value={formData.title || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Number of Days</Form.Label>
                    <Form.Control
                      type="number"
                      name="noofDays"
                      value={formData.noofDays || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Total Hours</Form.Label>
                    <Form.Control
                      type="number"
                      name="totalHours"
                      value={formData.totalHours || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Rate</Form.Label>
                    <Form.Control
                      type="number"
                      name="rate"
                      value={formData.rate || ""}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAdd}>
            Add
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
}